import React from "react"
import Responsive from "react-responsive"

const MobileTitleBar = ({children}) => (
  <Responsive maxWidth={790}>
    <div className="MobileHeader-background ph3-ns ph2">
      <div className="f3 db pv2 pv3-ns">{children}</div>
    </div>
  </Responsive>
)

export default MobileTitleBar



// WEBPACK FOOTER //
// ./src/components/MobileTitleBar.js